import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Select } from "@ngxs/store";
import { Observable, Subscription } from "rxjs";
import { AppState } from "src/app/app-state";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { MessageService } from "src/app/injectable/message.service";
import { Message } from "src/app/model/message";
import { DialogSentMessageComponent } from "src/app/shared/components/dialog/dialog-sent-message/dialog-sent-message.component";
import { ExtendMessageDialogComponent } from "../extend-message-dialog/extend-message-dialog.component";
import { Circle } from "../map-drawing-radius-tool/model/circle";
import { TerminateMessageDialogComponent } from "../terminate-message-dialog/terminate-message-dialog.component";

@Component({
  selector: "app-message-detail",
  templateUrl: "./message-detail.component.html",
  styleUrls: ["./message-detail.component.scss"],
})
export class MessageDetailComponent implements OnInit, OnDestroy {
  @Select(AppState.isUserAdmin) isUserAdmin$: Observable<boolean>;

  loading = false;
  sub = false;
  private subscription: Subscription = new Subscription();
  messageDetail;
  circle: Circle;
  serverMessage: any = "";
  isUserAdmin: any;
  showMap = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private adminService: AdminService,
    private genericErrorModalService: GenericErrorModalService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.isUserAdmin$.subscribe((value) => {
        this.isUserAdmin = value;
        if (!(value === undefined)) this.loadMessageDetail();
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onBackButtonClick() {
    this.router.navigate(["/messages"]);
  }

  loadMessageDetail() {
    this.subscription = this.route.params.subscribe((params) => {
      this.loading = true;
      const id = +params.id;
      let x = true;
      this.messageService.getMessage(id.toString()).subscribe(
        (data) => {
          this.loading = false;
          let validity;
          if (data.messageStatusId === 92) {
            validity = 4;
          } else {
            if (new Date(data.startDate).getTime() < new Date().getTime()) {
              if (new Date(data.endDate).getTime() < new Date().getTime()) {
                validity = 3;
              } else {
                validity = 2;
              }
            } else {
              validity = 1;
            }
          }
          if (data.messageTypeId == "4") {
            // Per Raggio
            this.circle = {
              latitude: data.latitude,
              longitude: data.longitude,
              radius: data.radiusKm * 1000,
            };
          }
          data.validity = validity;
          this.messageDetail = data;
          this.showMap = true;
          x = false;
        },
        (error) => {
          this.loading = false;
          this.genericErrorModalService.open(
            "Questo messaggio non esiste",
            error
          );
          this.showMap = true;
        }
      );
      if (x) return;
      this.showMap = true;
    });
  }

  terminateMessage(id: number) {
    this.openTerminateMessageDialog(id);
  }

  extendMessage(message: Message) {
    this.openExtendMessageDialog(message);
  }

  openTerminateMessageDialog(id: number) {
    const dialogRef = this.dialog.open(TerminateMessageDialogComponent, {
      width: "400px",
    });
    dialogRef.afterClosed().subscribe((choice) => {
      if (choice == "terminate") {
        // terminate message
        this.sub = true;
        this.messageService.terminateMessage(id.toString()).subscribe(
          (response) => {
            this.sub = false;
            this.serverMessage = response;
            // for (let i = 0; i < this.dataSource.data.length / 2; i++) {
            //   if (this.messages[i].id == id) {
            //     this.dataSource.data[i].messageStatusId = 5;
            //     this.dataSource.data[i].validity = 4;
            //   }
            // }
            // refresh lista messaggi
            this.router
              .navigateByUrl("/refreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["/messages"]);
              });
            // open successSnack
            this.openSuccessDialogSentMessage(
              "Messaggio annullato.",
              /*this.serverMessage.message*/ "Messaggio annullato con successo!"
            );
          },
          (err) => {
            this.sub = false;
            this.serverMessage = new Error();
            this.serverMessage.message = err.error.message;
            // refresh lista messaggi
            this.router
              .navigateByUrl("/refreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["/messages"]);
              });
            this.genericErrorModalService.open(
              "Errore nella terminazione del messaggio",
              err
            );
            // this.openErrorDialogSentMessage('Errore nella terminazione del messaggio', err.error.errorCode);
          }
        );
      }
      if (choice == "cancel") {
      }
    });
  }

  openExtendMessageDialog(message: Message) {
    const dialogRef = this.dialog.open(ExtendMessageDialogComponent, {
      width: "400px",
      data: {
        id: message.id,
        scadenza: message.endDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.message == "prorogate") {
        // terminate message
        const newEndDate: Date = new Date(result.newEndDate);
        this.messageService
          .prorogateMessage(message.id.toString(), newEndDate.toISOString())
          .subscribe(
            (response) => {
              this.serverMessage = response;
              // for (let i = 0; i < this.dataSource.data.length/2; i++) {
              //   if (this.messages[i].id == message.id) {
              //     this.dataSource.data[i].messageStatusId = 5;
              //     this.dataSource.data[i].validity = 4;
              //   }
              // }
              // refresh lista messaggi
              this.router
                .navigateByUrl("/refreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => {
                  this.router.navigate(["/messages"]);
                });
              // open successSnack
              this.openSuccessDialogSentMessage(
                "Messaggio prorogato.",
                "MES06"
              );
            },
            (err) => {
              // refresh lista messaggi
              this.router
                .navigateByUrl("/refreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => {
                  this.router.navigate(["/messages"]);
                });
              // open ErrorDialog
              this.genericErrorModalService.open(
                "Errore nella prorogazione del messaggio",
                err
              );
              // this.openErrorDialogSentMessage('Errore nella prorogazione del messaggio', err.error.errorCode)
            }
          );
      } else {
      }
    });
  }

  openSuccessDialogSentMessage(message: string, result: string): void {
    const dialogRef = this.dialog.open(DialogSentMessageComponent, {
      width: "500px",
      height: "220px",
      data: {
        message,
        result,
      },
    });
  }
}
